const clearFromCache = (cacheKey) => {
  localStorage.removeItem(cacheKey);
  localStorage.removeItem(`${cacheKey}_ttl`);
};

export const getFromCache = (cacheKey) => {
  const cacheTtl = localStorage.getItem(`${cacheKey}_ttl`);
  const cachedData = localStorage.getItem(cacheKey);
  const now = Date.now();

  if (cachedData && cacheTtl > now) {
    return JSON.parse(cachedData);
  }
};

export const saveToCache = (cacheKey, data) => {
  const ttlDurationInMinutes = 640;
  const ttlDuration = ttlDurationInMinutes * 60 * 1000;

  localStorage.setItem(cacheKey, JSON.stringify(data));
  localStorage.setItem(`${cacheKey}_ttl`, Date.now() + ttlDuration);
};

export const isValidCachedData = (cacheKey) => {
  if (!localStorage.getItem(cacheKey)) {
    return false;
  }

  if (Date.now() > localStorage.getItem(`${cacheKey}_ttl`)) {
    clearFromCache(cacheKey);
    return false;
  }

  return true;
};

export const clearCacheStorage = () => {
  const keys = Object.keys(localStorage);
  const ttlKeys = keys.filter(key => key.includes('_ttl'));
  localStorage.removeItem('formFiltro');
  ttlKeys.forEach(ttlKey => {
    localStorage.removeItem(ttlKey);
    const baseKey = ttlKey.replace('_ttl', '');

    if (localStorage.getItem(baseKey)) {
      localStorage.removeItem(baseKey);
    }
  });
}
